import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsPlansTasksList: build.query<
      ApiPortalV1AssessmentsPlansTasksListApiResponse,
      ApiPortalV1AssessmentsPlansTasksListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/tasks/`,
        params: {
          assessment_period_action_plan_id:
            queryArg.assessmentPeriodActionPlanId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansTasksCreate: build.mutation<
      ApiPortalV1AssessmentsPlansTasksCreateApiResponse,
      ApiPortalV1AssessmentsPlansTasksCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/tasks/`,
        method: "POST",
        body: queryArg.assessmentPeriodActionPlanTask,
      }),
    }),
    apiPortalV1AssessmentsPlansTasksRetrieve: build.query<
      ApiPortalV1AssessmentsPlansTasksRetrieveApiResponse,
      ApiPortalV1AssessmentsPlansTasksRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/tasks/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsPlansTasksUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansTasksUpdateApiResponse,
      ApiPortalV1AssessmentsPlansTasksUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/tasks/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.assessmentPeriodActionPlanTask,
        params: {
          assessment_period_action_plan_task_id:
            queryArg.assessmentPeriodActionPlanTaskId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansTasksPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansTasksPartialUpdateApiResponse,
      ApiPortalV1AssessmentsPlansTasksPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/tasks/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedAssessmentPeriodActionPlanTask,
      }),
    }),
    apiPortalV1AssessmentsPlansTasksDestroy: build.mutation<
      ApiPortalV1AssessmentsPlansTasksDestroyApiResponse,
      ApiPortalV1AssessmentsPlansTasksDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/tasks/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsPlansTasksListApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanTaskRead[];
export type ApiPortalV1AssessmentsPlansTasksListApiArg = {
  assessmentPeriodActionPlanId: number;
};
export type ApiPortalV1AssessmentsPlansTasksCreateApiResponse =
  /** status 201  */ AssessmentPeriodActionPlanTaskRead;
export type ApiPortalV1AssessmentsPlansTasksCreateApiArg = {
  assessmentPeriodActionPlanTask: AssessmentPeriodActionPlanTask;
};
export type ApiPortalV1AssessmentsPlansTasksRetrieveApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanTaskRead;
export type ApiPortalV1AssessmentsPlansTasksRetrieveApiArg = {
  /** A unique integer value identifying this assessment period action plan task. */
  id: number;
};
export type ApiPortalV1AssessmentsPlansTasksUpdateApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanTaskRead;
export type ApiPortalV1AssessmentsPlansTasksUpdateApiArg = {
  assessmentPeriodActionPlanTaskId: number;
  /** A unique integer value identifying this assessment period action plan task. */
  id: number;
  assessmentPeriodActionPlanTask: AssessmentPeriodActionPlanTask;
};
export type ApiPortalV1AssessmentsPlansTasksPartialUpdateApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanTaskRead;
export type ApiPortalV1AssessmentsPlansTasksPartialUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan task. */
  id: number;
  patchedAssessmentPeriodActionPlanTask: PatchedAssessmentPeriodActionPlanTask;
};
export type ApiPortalV1AssessmentsPlansTasksDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsPlansTasksDestroyApiArg = {
  /** A unique integer value identifying this assessment period action plan task. */
  id: number;
};
export type PhaseIdEnum = 1 | 2 | 3;
export type AssessmentPeriodActionPlanTaskStatusEnum =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7;
export type AssessmentPeriodActionPlanTask = {
  phase_id?: PhaseIdEnum;
  activity_name?: string;
  b_corp_goal?: string | null;
  task_name?: string;
  task_sort_order?: number;
  activity_sort_order?: number;
  metric?: string | null;
  description: string;
  status?: AssessmentPeriodActionPlanTaskStatusEnum;
  start_date?: string | null;
  end_date?: string | null;
  notes?: string | null;
  resources?: any;
  content?: any;
  assessment_period_action_plan?: number;
  owner?: number | null;
};
export type ActionPlanStatusEnum = 1 | 2 | 3 | 4 | 5 | 11 | 99;
export type ActionPlan = {
  employee?: number | null;
  organization?: number | null;
  metric: string;
  primary?: string | null;
  assignees?: number[];
  sort_order?: number | null;
  plan?: any | null;
  question?: any | null;
  status?: ActionPlanStatusEnum;
  start_date: string;
  end_date: string;
  created_by?: number | null;
};
export type ActionPlanRead = {
  id: number;
  employee?: number | null;
  organization?: number | null;
  metric: string;
  primary?: string | null;
  assignees?: number[];
  sort_order?: number | null;
  plan?: any | null;
  question?: any | null;
  status?: ActionPlanStatusEnum;
  status_text: string;
  start_date: string;
  end_date: string;
  created_by?: number | null;
  created_at: string;
  updated_at: string;
};
export type AssessmentPeriodActionPlanTaskRead = {
  id: number;
  action_plan: ActionPlanRead;
  phase_id?: PhaseIdEnum;
  activity_name?: string;
  b_corp_goal?: string | null;
  task_name?: string;
  task_sort_order?: number;
  activity_sort_order?: number;
  metric?: string | null;
  description: string;
  status?: AssessmentPeriodActionPlanTaskStatusEnum;
  start_date?: string | null;
  end_date?: string | null;
  notes?: string | null;
  resources?: any;
  content?: any;
  assessment_period_action_plan?: number;
  owner?: number | null;
};
export type PatchedAssessmentPeriodActionPlanTask = {
  phase_id?: PhaseIdEnum;
  activity_name?: string;
  b_corp_goal?: string | null;
  task_name?: string;
  task_sort_order?: number;
  activity_sort_order?: number;
  metric?: string | null;
  description?: string;
  status?: AssessmentPeriodActionPlanTaskStatusEnum;
  start_date?: string | null;
  end_date?: string | null;
  notes?: string | null;
  resources?: any;
  content?: any;
  assessment_period_action_plan?: number;
  owner?: number | null;
};
export type PatchedAssessmentPeriodActionPlanTaskRead = {
  id?: number;
  action_plan?: ActionPlanRead;
  phase_id?: PhaseIdEnum;
  activity_name?: string;
  b_corp_goal?: string | null;
  task_name?: string;
  task_sort_order?: number;
  activity_sort_order?: number;
  metric?: string | null;
  description?: string;
  status?: AssessmentPeriodActionPlanTaskStatusEnum;
  start_date?: string | null;
  end_date?: string | null;
  notes?: string | null;
  resources?: any;
  content?: any;
  assessment_period_action_plan?: number;
  owner?: number | null;
};
export const {
  useApiPortalV1AssessmentsPlansTasksListQuery,
  useApiPortalV1AssessmentsPlansTasksCreateMutation,
  useApiPortalV1AssessmentsPlansTasksRetrieveQuery,
  useApiPortalV1AssessmentsPlansTasksUpdateMutation,
  useApiPortalV1AssessmentsPlansTasksPartialUpdateMutation,
  useApiPortalV1AssessmentsPlansTasksDestroyMutation,
} = injectedRtkApi;
